import { defineMessages } from 'react-intl';

const messages = defineMessages({
  add: {
    id: 'pages.modal.addtobasket',
    defaultMessage: 'Add to basket',
  },
  inBasket: {
    id: 'pages.modal.inBasket',
    defaultMessage: 'In basket',
  },
  editMenu: {
    id: 'pages.modal.editMenu',
    defaultMessage: 'Edit',
  },
  deleteAsset: {
    id: 'pages.modal.deleteAsset',
    defaultMessage: 'Delete',
  },
  deletedAsset: {
    id: 'pages.modal.deletedAsset',
    defaultMessage: 'Asset moved to trash.',
  },
  replaceConfirmTitle: {
    id: 'pages.modal.replaceConfirmTitle',
    defaultMessage: 'Replace original content?',
  },
  replaceDeletesFormats: {
    id: 'pages.modal.replaceDeletesFormats',
    defaultMessage:
      'Replacing the file regenerates {count, plural, one {the stored format} =2 {both stored formats} other {all # stored formats}} of this asset that your account settings generate. The current ones stay available until the new ones are ready, which can take a while.',
  },
  replaceNotRecreatedNote: {
    id: 'pages.modal.replaceNotRecreatedNote',
    defaultMessage:
      '{count, plural, one {The format marked below was} other {The # formats marked below were}} saved to this asset individually and will be deleted.',
  },
  replaceNotRecreatedBadge: {
    id: 'pages.modal.replaceNotRecreatedBadge',
    defaultMessage: 'Not recreated',
  },
  replaceKeepFormatsHint: {
    id: 'pages.modal.replaceKeepFormatsHint',
    defaultMessage: 'To keep the current formats as they are, upload the new file as a new asset instead.',
  },
  replaceUploadAsNew: {
    id: 'pages.modal.replaceUploadAsNew',
    defaultMessage: 'Upload as new asset',
  },
  replaceAnyway: {
    id: 'pages.modal.replaceAnyway',
    defaultMessage: 'Replace anyway',
  },
  deleteConfirmTitle: {
    id: 'pages.modal.deleteConfirmTitle',
    defaultMessage: 'Delete this asset?',
  },
  deleteConfirmMessage: {
    id: 'pages.modal.deleteConfirmMessage',
    defaultMessage: 'The asset will be moved to trash and can be restored from there.',
  },
  downloadContent: {
    id: 'pages.modal.downloadContent',
    defaultMessage: 'Download',
  },
  getLinkContent:{
    id: 'pages.modal.getLinkContent',
    defaultMessage: 'Get Link',
  },
  findDuplicates: {
    id: 'pages.modal.findDuplicates',
    defaultMessage: 'Find duplicates',
  },
  replaceContent: {
    id: 'pages.modal.replaceContent',
    defaultMessage: 'Replace Content',
  },
  changeThumbnail: {
    id: 'pages.modal.changeThumbnail',
    defaultMessage: 'Change Thumbnail',
  },
  editImage: {
    id: 'pages.modal.editImage',
    defaultMessage: 'Edit Image',
  },
  cancelEditImage: {
    id: 'pages.modal.cancelEditImage',
    defaultMessage: 'Close Edit Mode',
  },
  back: {
    id: 'pages.modal.back',
    defaultMessage: 'Back',
  },
  metadata: {
    id: 'pages.modal.metadata',
    defaultMessage: 'Metadata',
  },
  core: {
    id: 'pages.modal.core',
    defaultMessage: 'Core data',
  },
  conversions: {
    id: 'pages.modal.conversions',
    defaultMessage: 'Formats',
  },
  addon: {
    id: 'pages.modal.addOn',
    defaultMessage: 'Add-on',
  },
  relationships: {
    id: 'pages.modal.relationships',
    defaultMessage: 'Relationships',
  },
  versions: {
    id: 'pages.modal.versions',
    defaultMessage: 'Versions',
  },
  customMetadata: {
    id: 'pages.modal.customMetadata',
    defaultMessage: 'Custom Metadata',
  },
  customMetadataContent: {
    id: 'pages.modal.customMetadataContent',
    defaultMessage: 'Dynamically create and display product images that highlight the product by perfectly blending.',
  },
  goBack: {
    id: 'pages.modal.goBack',
    defaultMessage: 'Go Back',
  },
  saveConversion: {
    id: 'pages.modal.saveConversion',
    defaultMessage: 'Save into Asset as a Conversion',
  },
  saveNewAsset: {
    id: 'pages.modal.saveNewAsset',
    defaultMessage: 'Save into New Asset ',
  },
  assetUpdateDialogTitle: {
    id: 'pages.modal.assetUpdateDialogTitle',
    defaultMessage: 'Edited Copy of Image',
  },
  replaceOriginalImageNote: {
    id: 'pages.modal.replaceOriginalImageNote',
    defaultMessage: `WARNING: This will remove all the conventions and start all the Conventions.`,
  },
  replaceOriginalImage: {
    id: 'pages.modal.replaceOriginalImage',
    defaultMessage: `Replace Original {assetType}`,
  },
  addAsAConversion: {
    id: 'pages.modal.addAsAConversion',
    defaultMessage: 'Add as a Conversion',
  },
  downloadEditedCopy: {
    id: 'pages.modal.downloadEditedCopy',
    defaultMessage: 'Download Edited Copy',
  },
  addonNotEnabled: {
    id: 'pages.modal.addonNotEnabled',
    defaultMessage: 'Addon Not Enabled Please Contact Support',
  },
  addAsNewAsset: {
    id: 'pages.modal.addAsNewAsset',
    defaultMessage: 'Add As New Asset',
  },
  cancel: {
    id: 'pages.modal.cancel',
    defaultMessage: 'Cancel',
  },
  addFreeFormData: {
    id: 'pages.modal.addFreeFormData',
    defaultMessage: 'Add Free Form Data',
  },
  assetMetadataSetupInfo: {
    id: 'pages.modal.assetMetadataSetupInfo',
    defaultMessage:
      "It seems that you don't have any metadata nor any schema for your metadata, choose one of the two:",
  },
  selectSchema: {
    id: 'pages.modal.selectSchema',
    defaultMessage: 'Select a schema for your metadata:',
  },
  submit: {
    id: 'pages.modal.submit',
    defaultMessage: 'Submit',
  },
  addField: {
    id: 'pages.modal.addField',
    defaultMessage: 'Add Field',
  },
  successfullyReplacedOriginalImage: {
    id: 'pages.modal.successfullyReplacedOriginalImage',
    defaultMessage:
      'Sucessfuly replaced original asset, this might take a while to update, This will also remove all the conventions and start the reprocessing.',
  },
  newAssetcreated: {
    id: 'pages.modal.newAssetcreated',
    defaultMessage: 'The new asset is created successfully',
  },
  subtitleUpdated: {
    id: 'pages.modal.subtitleUpdated',
    defaultMessage: 'Subtitle updated successfully',
  },
  // A save is an upload; a write-blocked account (trial ended without a card,
  // spend limit reached) is refused with 403 at the upload auth or 503 from
  // the write gate. 403 can also be a plain permission refusal, so its copy
  // covers both.
  saveRefused: {
    id: 'pages.modal.saveRefused',
    defaultMessage: "Couldn't save: uploads aren't allowed for this account right now.",
  },
  savePaused: {
    id: 'pages.modal.savePaused',
    defaultMessage: "Couldn't save: uploads and processing are paused for this account.",
  },
  saveFailed: {
    id: 'pages.modal.saveFailed',
    defaultMessage: "Couldn't save the image. Please try again.",
  },
  savedConversion: {
    id: 'pages.modal.savedConversion',
    defaultMessage: `Sucessfully saved {conversionName} as an asset conversion`,
  },
  addedNewAsset: {
    id: 'pages.modal.addedNewAsset',
    defaultMessage: `Sucessfully Added as New Asset in the Dashboard`,
  },
  replaceOriginal: {
    id: 'pages.modal.replaceOriginal',
    defaultMessage: `Sucessfuly replaced original {type}, this might take a while to update.`,
  },
  editConfirmDialogTitle: {
    id: 'pages.modal.editConfirmDialogTitle',
    defaultMessage: 'Do you want to edit another conversion?',
  },
  editConfirmDialogMessage: {
    id: 'pages.modal.editConfirmDialogMessage',
    defaultMessage: 'You will lose all your changes if you proceed.',
  },
  addedToBasket: {
    id: 'pages.modal.addedToBasket',
    defaultMessage: 'Sucessfully added asset to basket',
  },
  removedFromBasket: {
    id: 'pages.modal.removedFromBasket',
    defaultMessage: 'Sucessfully removed asset from basket',
  },
  // "Edit with AI" -> "Enhance with AI": cut-out work moved to its own
  // task-named item, so this menu entry now covers only the enhancement family
  // (Auto Enhance, AI Restore, Custom enhancement).
  aiEditImage: {
    id: 'pages.modal.aiEditImage',
    defaultMessage: 'Enhance with AI',
  },
  exportForPrint: {
    id: 'pages.modal.exportForPrint',
    defaultMessage: 'Export for Print',
  },
  printExportProcessing: {
    id: 'pages.modal.printExportProcessing',
    defaultMessage: 'Generating your print file…',
  },
  printExportNotify: {
    id: 'pages.modal.printExportNotify',
    defaultMessage:
      'Your print export is still processing. You can close this dialog — we’ll notify you when it’s ready, and it will appear under Jobs.',
  },
  printExportSavedConversion: {
    id: 'pages.modal.printExportSavedConversion',
    defaultMessage: 'Print file saved as conversion “{conversionName}”.',
  },
  printExportSavedNewAsset: {
    id: 'pages.modal.printExportSavedNewAsset',
    defaultMessage: 'Print file saved as a new asset.',
  },
  printExportDownloadStarted: {
    id: 'pages.modal.printExportDownloadStarted',
    defaultMessage: 'Your print file download has started.',
  },
  printExportFailed: {
    id: 'pages.modal.printExportFailed',
    defaultMessage: 'Print export failed. Please try again.',
  },
  printExportNotEnabled: {
    id: 'pages.modal.printExportNotEnabled',
    defaultMessage: 'Print Export is not enabled for your account.',
  },
  printExportQuotaExhausted: {
    id: 'pages.modal.printExportQuotaExhausted',
    defaultMessage: "This month's print exports are used up. Choose a plan to export more.",
  },
  printExportOverageShortAdmin: {
    id: 'pages.modal.printExportOverageShortAdmin',
    defaultMessage:
      "You've used this month's included print exports. Each extra export costs {credits} credits and the account has {balance}. Add credits on the Subscription page to keep exporting.",
  },
  printExportOverageShortMember: {
    id: 'pages.modal.printExportOverageShortMember',
    defaultMessage:
      "You've used this month's included print exports. Each extra export costs {credits} credits and the account has {balance}. Ask your account owner to add credits.",
  },
  printExportInsufficientCredits: {
    id: 'pages.modal.printExportInsufficientCredits',
    defaultMessage: 'Not enough credits for upscaling (need {required}, have {balance}).',
  },
  aiOpAutoEnhance: {
    id: 'pages.modal.aiOpAutoEnhance',
    defaultMessage: 'Auto Enhance',
  },
  aiOpWhiteBalance: {
    id: 'pages.modal.aiOpWhiteBalance',
    defaultMessage: 'White Balance',
  },
  aiOpExposure: {
    id: 'pages.modal.aiOpExposure',
    defaultMessage: 'Exposure',
  },
  aiOpColor: {
    id: 'pages.modal.aiOpColor',
    defaultMessage: 'Color',
  },
  aiOpDeblur: {
    id: 'pages.modal.aiOpDeblur',
    defaultMessage: 'Deblur',
  },
  aiOpUpscale: {
    id: 'pages.modal.aiOpUpscale',
    defaultMessage: 'Upscale',
  },
  aiOpFaceRestore: {
    id: 'pages.modal.aiOpFaceRestore',
    defaultMessage: 'Face Restore',
  },
  aiOpWhiteBalanceDesc: {
    id: 'pages.modal.aiOpWhiteBalanceDesc',
    defaultMessage: 'Neutralize color casts for accurate whites.',
  },
  aiOpExposureDesc: {
    id: 'pages.modal.aiOpExposureDesc',
    defaultMessage: 'Fix under- or over-exposed areas.',
  },
  aiOpColorDesc: {
    id: 'pages.modal.aiOpColorDesc',
    defaultMessage: 'Balance and enrich color.',
  },
  aiOpDeblurDesc: {
    id: 'pages.modal.aiOpDeblurDesc',
    defaultMessage: 'Sharpen soft or blurry details.',
  },
  aiOpUpscaleDesc: {
    id: 'pages.modal.aiOpUpscaleDesc',
    defaultMessage: 'Increase resolution and size.',
  },
  aiOpFaceRestoreDesc: {
    id: 'pages.modal.aiOpFaceRestoreDesc',
    defaultMessage: 'Restore and sharpen facial details.',
  },
  aiEditAutoEnhance: {
    id: 'pages.modal.aiEditAutoEnhance',
    defaultMessage: 'Auto Enhance',
  },
  aiEditAutoEnhanceDesc: {
    id: 'pages.modal.aiEditAutoEnhanceDesc',
    defaultMessage: 'One-click cleanup: sharpen and gently balance color, contrast and exposure. Your photo is improved, not redrawn.',
  },
  aiEditAiRestore: {
    id: 'pages.modal.aiEditAiRestore',
    defaultMessage: 'AI Restore',
  },
  aiEditAiRestoreDesc: {
    id: 'pages.modal.aiEditAiRestoreDesc',
    defaultMessage: 'Generative restoration that rebuilds detail in damaged, old or low-quality photos. This substantially alters the image.',
  },
  aiEditEnhanceTooSmall: {
    id: 'pages.modal.aiEditEnhanceTooSmall',
    defaultMessage: 'Enhance needs an image at least 512×512 px. Try AI Restore instead.',
  },
  aiEditGenerative: {
    id: 'pages.modal.aiEditGenerative',
    defaultMessage: 'Generative',
  },
  aiEditRecommended: {
    id: 'pages.modal.aiEditRecommended',
    defaultMessage: 'Recommended',
  },
  aiEditCustomize: {
    id: 'pages.modal.aiEditCustomize',
    defaultMessage: 'Custom enhancement',
  },
  aiEditCustomizeHint: {
    id: 'pages.modal.aiEditCustomizeHint',
    defaultMessage: 'Build your own pipeline of enhancement steps.',
  },
  aiEditResetAuto: {
    id: 'pages.modal.aiEditResetAuto',
    defaultMessage: 'Reset to Auto Enhance',
  },
  adobePlugin: {
    id: 'pages.modal.adobePlugin',
    defaultMessage: 'Edit in Adobe apps…',
  },
  aiRemovePresetGhost: {
    id: 'pages.modal.aiRemovePresetGhost',
    defaultMessage: 'Ghost mannequin',
  },
  aiRemovePresetGhostHint: {
    id: 'pages.modal.aiRemovePresetGhostHint',
    defaultMessage:
      'For apparel shot on a mannequin or hanger: keeps the garment’s worn shape, hollow at the openings, on a clean background.',
  },
  aiRemovePresetIsolate: {
    id: 'pages.modal.aiRemovePresetIsolate',
    defaultMessage: 'Isolate on white',
  },
  aiRemovePresetIsolateHint: {
    id: 'pages.modal.aiRemovePresetIsolateHint',
    defaultMessage:
      'For product shots: keeps the product, removes the background and anything around it.',
  },
  aiRemovePresetErasePeople: {
    id: 'pages.modal.aiRemovePresetErasePeople',
    defaultMessage: 'Erase people',
  },
  aiRemovePresetErasePeopleHint: {
    id: 'pages.modal.aiRemovePresetErasePeopleHint',
    defaultMessage:
      'For venues and locations: removes people and fills the space to match the scene, keeping the setting.',
  },
  aiEditUsesCredits: {
    id: 'pages.modal.aiEditUsesCredits',
    defaultMessage: 'Uses credits',
  },
  // Plural-aware: rates are sysadmin-editable, so 1 is reachable.
  aiEditCredits: {
    id: 'pages.modal.aiEditCredits',
    defaultMessage: '{credits, plural, one {# credit} other {# credits}}',
  },
  aiEditCostApplyPreview: {
    id: 'pages.modal.aiEditCostApplyPreview',
    defaultMessage: '{apply} credits to apply \u00b7 {preview} per preview',
  },
  aiEditModeSequence: {
    id: 'pages.modal.aiEditModeSequence',
    defaultMessage: 'Multi-step',
  },
  aiEditSequenceTitle: {
    id: 'pages.modal.aiEditSequenceTitle',
    defaultMessage: 'Steps',
  },
  aiEditAddStep: {
    id: 'pages.modal.aiEditAddStep',
    defaultMessage: 'Add step',
  },
  aiEditStepEnabled: {
    id: 'pages.modal.aiEditStepEnabled',
    defaultMessage: 'Enable step',
  },
  aiEditRemoveStep: {
    id: 'pages.modal.aiEditRemoveStep',
    defaultMessage: 'Remove step',
  },
  aiEditDragHint: {
    id: 'pages.modal.aiEditDragHint',
    defaultMessage: 'Steps run top to bottom. Drag to reorder, toggle on or off; the whole edit is one charge.',
  },
  aiEditSequenceNeedsStep: {
    id: 'pages.modal.aiEditSequenceNeedsStep',
    defaultMessage: 'Add at least one step and enable it to apply.',
  },
  aiEditUpscaleFactor: {
    id: 'pages.modal.aiEditUpscaleFactor',
    defaultMessage: 'Upscale factor',
  },
  aiEditApply: {
    id: 'pages.modal.aiEditApply',
    defaultMessage: 'Apply',
  },
  aiEditReapply: {
    id: 'pages.modal.aiEditReapply',
    defaultMessage: 'Apply again',
  },
  aiEditApplyHint: {
    id: 'pages.modal.aiEditApplyHint',
    defaultMessage: 'Each apply uses credits.',
  },
  aiEditApplying: {
    id: 'pages.modal.aiEditApplying',
    defaultMessage: 'Applying…',
  },
  aiEditProcessing: {
    id: 'pages.modal.aiEditProcessing',
    defaultMessage: 'Processing your image…',
  },
  aiEditShowOriginal: {
    id: 'pages.modal.aiEditShowOriginal',
    defaultMessage: 'Show original',
  },
  aiEditBefore: {
    id: 'pages.modal.aiEditBefore',
    defaultMessage: 'Before',
  },
  aiEditAfter: {
    id: 'pages.modal.aiEditAfter',
    defaultMessage: 'After',
  },
  aiEditSaveResult: {
    id: 'pages.modal.aiEditSaveResult',
    defaultMessage: 'Save result',
  },
  aiEditFeedbackPrompt: {
    id: 'pages.modal.aiEditFeedbackPrompt',
    defaultMessage: 'Saved. How did the result look?',
  },
  aiEditFeedbackGood: {
    id: 'pages.modal.aiEditFeedbackGood',
    defaultMessage: '👍 Good',
  },
  aiEditFeedbackBad: {
    id: 'pages.modal.aiEditFeedbackBad',
    defaultMessage: '👎 Needs work',
  },
  aiEditFeedbackSkip: {
    id: 'pages.modal.aiEditFeedbackSkip',
    defaultMessage: 'Done',
  },
  aiEditAddNewAsset: {
    id: 'pages.modal.aiEditAddNewAsset',
    defaultMessage: 'Add as New Asset',
  },
  aiEditAddConversion: {
    id: 'pages.modal.aiEditAddConversion',
    defaultMessage: 'Add as Conversion',
  },
  aiEditStartOver: {
    id: 'pages.modal.aiEditStartOver',
    defaultMessage: 'Start over',
  },
  aiEditConfirm: {
    id: 'pages.modal.aiEditConfirm',
    defaultMessage: 'Confirm',
  },
  aiEditConversionName: {
    id: 'pages.modal.aiEditConversionName',
    defaultMessage: 'Conversion name',
  },
  aiEditConversionPlaceholder: {
    id: 'pages.modal.aiEditConversionPlaceholder',
    defaultMessage: 'Type a name for the conversion',
  },
  aiEditNewAssetName: {
    id: 'pages.modal.aiEditNewAssetName',
    defaultMessage: 'New asset name (optional)',
  },
  aiEditNewAssetPlaceholder: {
    id: 'pages.modal.aiEditNewAssetPlaceholder',
    defaultMessage: 'Leave blank to keep the original name',
  },
  aiEditNoExtensionNote: {
    id: 'pages.modal.aiEditNoExtensionNote',
    defaultMessage: 'No file extension needed; it is added automatically.',
  },
  aiEditNameRequired: {
    id: 'pages.modal.aiEditNameRequired',
    defaultMessage: 'Name is required',
  },
  aiEditNameTooLong: {
    id: 'pages.modal.aiEditNameTooLong',
    defaultMessage: 'Name must be 20 characters or less',
  },
  aiEditNameInvalid: {
    id: 'pages.modal.aiEditNameInvalid',
    defaultMessage: 'Name must be alphanumeric and can contain "-" and "_"',
  },
  aiEditCreditsCharged: {
    id: 'pages.modal.aiEditCreditsCharged',
    defaultMessage: 'Charged {credits} credit(s)',
  },
  aiEditInsufficientCredits: {
    id: 'pages.modal.aiEditInsufficientCredits',
    defaultMessage: 'Not enough credits: {required} required, {balance} available',
  },
  aiEditSavedConversion: {
    id: 'pages.modal.aiEditSavedConversion',
    defaultMessage: 'Saved as conversion "{conversionName}"',
  },
  aiEditSavedNewAsset: {
    id: 'pages.modal.aiEditSavedNewAsset',
    defaultMessage: 'Saved as a new asset',
  },
  aiEditProcessingConversion: {
    id: 'pages.modal.aiEditProcessingConversion',
    defaultMessage:
      'Your edit is being processed. The conversion "{conversionName}" will appear once the background job completes.',
  },
  aiEditProcessingNewAsset: {
    id: 'pages.modal.aiEditProcessingNewAsset',
    defaultMessage: 'Your edit is being processed. The new asset will appear once the background job completes.',
  },
  aiEditFailed: {
    id: 'pages.modal.aiEditFailed',
    defaultMessage: 'AI image edit failed. Please try again.',
  },
  aiEditTimedOut: {
    id: 'pages.modal.aiEditTimedOut',
    defaultMessage: 'The edit is taking longer than expected. Please try again.',
  },
  // ---------------------------------------------------------------------
  // Cut out / change background
  //
  // The copy names the RESULT, not the operation, and says "subject" rather
  // than "product" throughout: the cut-out applies to a person or any
  // foreground object, not only retail goods. Only the ghost-mannequin strings
  // are garment-specific, because the operation is.
  // ---------------------------------------------------------------------
  cutoutMenu: {
    id: 'pages.modal.cutoutMenu',
    defaultMessage: 'Cut out / change background',
  },
  cutoutPrompt: {
    id: 'pages.modal.cutoutPrompt',
    defaultMessage: 'Choose the output you need',
  },
  cutoutGenerativeBadge: {
    id: 'pages.modal.cutoutGenerativeBadge',
    defaultMessage: 'Generative',
  },
  cutoutGenerativeNote: {
    id: 'pages.modal.cutoutGenerativeNote',
    // Adds to the outcome description rather than repeating it: the tile
    // already says the photo is repainted, this says what that costs.
    defaultMessage:
      'The whole image is regenerated, so fine details can shift from the original. Compare the preview before you save.',
  },
  cutoutTransparent: {
    id: 'pages.modal.cutoutTransparent',
    defaultMessage: 'Remove Background (transparent PNG)',
  },
  cutoutTransparentDesc: {
    id: 'pages.modal.cutoutTransparentDesc',
    defaultMessage:
      'Cuts out the subject \u2014 a person, a product, anything in the foreground \u2014 and makes the background transparent.',
  },
  cutoutWhiteStudio: {
    id: 'pages.modal.cutoutWhiteStudio',
    defaultMessage: 'Remove Background (white studio background)',
  },
  cutoutWhiteStudioDesc: {
    id: 'pages.modal.cutoutWhiteStudioDesc',
    defaultMessage: 'Cuts the subject out, then places it on plain white.',
  },
  cutoutGhostMannequin: {
    id: 'pages.modal.cutoutGhostMannequin',
    defaultMessage: 'Ghost mannequin',
  },
  cutoutGhostMannequinDesc: {
    id: 'pages.modal.cutoutGhostMannequinDesc',
    defaultMessage:
      'For worn clothing. Rebuilds the collar and openings so the garment holds its shape with nobody inside it. Repaints the photo rather than cutting it out.',
  },
  cutoutClearClutter: {
    id: 'pages.modal.cutoutClearClutter',
    defaultMessage: 'Clear the clutter',
  },
  cutoutClearClutterDesc: {
    id: 'pages.modal.cutoutClearClutterDesc',
    defaultMessage:
      'Removes bystanders, hangers, stands, signage and other distractions around your subject, then fills in what was behind them. Repaints the photo rather than cutting it out.',
  },
  cutoutBack: {
    id: 'pages.modal.cutoutBack',
    defaultMessage: 'Back',
  },
  cutoutChange: {
    id: 'pages.modal.cutoutChange',
    defaultMessage: 'Change',
  },
  cutoutAdjust: {
    id: 'pages.modal.cutoutAdjust',
    defaultMessage: 'Adjust',
  },
  cutoutOptional: {
    id: 'pages.modal.cutoutOptional',
    defaultMessage: 'optional',
  },
  cutoutSubjectLabel: {
    id: 'pages.modal.cutoutSubjectLabel',
    defaultMessage: 'Subject of this photo',
  },
  cutoutSubjectDetected: {
    id: 'pages.modal.cutoutSubjectDetected',
    defaultMessage: 'Detected: {subject}',
  },
  cutoutSubjectDetecting: {
    id: 'pages.modal.cutoutSubjectDetecting',
    defaultMessage: 'Reading the photo\u2026',
  },
  cutoutSubjectHint: {
    id: 'pages.modal.cutoutSubjectHint',
    defaultMessage: 'Read from the photo. You only need to touch this if it named the wrong thing.',
  },
  cutoutAlsoRemove: {
    id: 'pages.modal.cutoutAlsoRemove',
    defaultMessage: 'Also remove',
  },
  cutoutAlsoRemoveHint: {
    id: 'pages.modal.cutoutAlsoRemoveHint',
    defaultMessage: 'Spotted in this photo. Tap to include or drop \u2014 no typing.',
  },
  aiEditInheritMetadata: {
    id: 'pages.modal.aiEditInheritMetadata',
    defaultMessage: 'Inherit metadata from the original',
  },
  aiEditInheritMetadataHint: {
    id: 'pages.modal.aiEditInheritMetadataHint',
    defaultMessage: 'Copies the tags and fields you have filled in on the source asset.',
  },
  cutoutBackgroundLabel: {
    id: 'pages.modal.cutoutBackgroundLabel',
    defaultMessage: 'Background',
  },
  cutoutBgTransparent: {
    id: 'pages.modal.cutoutBgTransparent',
    defaultMessage: 'Transparent',
  },
  cutoutBgWhite: {
    id: 'pages.modal.cutoutBgWhite',
    defaultMessage: 'White',
  },
  cutoutBackgroundHint: {
    id: 'pages.modal.cutoutBackgroundHint',
    defaultMessage:
      'Transparent drops into any layout. Pick white for the classic catalog shot.',
  },
  cutoutSubjectUnknown: {
    id: 'pages.modal.cutoutSubjectUnknown',
    defaultMessage: 'Could not tell \u2014 use Change to name it.',
  },
  cutoutRefineLabel: {
    id: 'pages.modal.cutoutRefineLabel',
    defaultMessage: 'Extra instructions',
  },
  cutoutRefinePlaceholder: {
    id: 'pages.modal.cutoutRefinePlaceholder',
    defaultMessage: 'e.g. keep the belt buckle sharp',
  },
  cutoutRefineCaveatRepaints: {
    id: 'pages.modal.cutoutRefineCaveatRepaints',
    defaultMessage:
      'Your words go to the model that repaints the photo, so they can change the subject itself \u2014 not only its surroundings.',
  },
  cutoutRefineCaveatShort: {
    id: 'pages.modal.cutoutRefineCaveatShort',
    defaultMessage:
      'One short, concrete instruction naming something you can see in the photo works best. Long descriptions tend to be ignored.',
  },
  cutoutRefineCaveatPreview: {
    id: 'pages.modal.cutoutRefineCaveatPreview',
    defaultMessage: 'Always preview before you apply, and compare against the original.',
  },
  cutoutAdjustBlocked: {
    id: 'pages.modal.cutoutAdjustBlocked',
    defaultMessage:
      '{outcome} cuts the subject out without repainting it, so it cannot erase things that overlap the subject.',
  },
  cutoutSwitchToGenerative: {
    id: 'pages.modal.cutoutSwitchToGenerative',
    defaultMessage: 'Switch to {outcome} ({credits} credits)',
  },
  // Same offer, for the moment before the rate card resolves.
  cutoutSwitchToGenerativePlain: {
    id: 'pages.modal.cutoutSwitchToGenerativePlain',
    defaultMessage: 'Switch to {outcome}',
  },
  cutoutCostMatte: {
    id: 'pages.modal.cutoutCostMatte',
    defaultMessage: '{credits} credits, preview included',
  },
  cutoutCostGenerative: {
    id: 'pages.modal.cutoutCostGenerative',
    defaultMessage:
      '{apply} credits to apply \u00b7 {preview} per preview \u00b7 {detect} for detection',
  },
  cutoutCredits: {
    id: 'pages.modal.cutoutCredits',
    defaultMessage: '{credits} credits',
  },

  // Batch (With Selected -> Remove background)
  cutoutBatchTitle: {
    id: 'pages.modal.cutoutBatchTitle',
    defaultMessage: 'Cut out the background',
  },
  cutoutBatchLede: {
    id: 'pages.modal.cutoutBatchLede',
    defaultMessage:
      '{count, plural, one {# selected image} other {# selected images}} will be processed one at a time in the background.',
  },
  cutoutBatchMatteOnly: {
    id: 'pages.modal.cutoutBatchMatteOnly',
    defaultMessage:
      'Ghost mannequin and Clear the clutter are per-image: they read each photo and take their own instructions, so they stay in the asset view.',
  },
  cutoutBatchSaveAs: {
    id: 'pages.modal.cutoutBatchSaveAs',
    defaultMessage: 'Save results as',
  },
  cutoutBatchNewAssets: {
    id: 'pages.modal.cutoutBatchNewAssets',
    defaultMessage: 'New assets',
  },
  cutoutBatchNewAssetsDesc: {
    id: 'pages.modal.cutoutBatchNewAssetsDesc',
    defaultMessage: 'One new asset per image, linked back to the original.',
  },
  cutoutBatchConversions: {
    id: 'pages.modal.cutoutBatchConversions',
    defaultMessage: 'Formats on the originals',
  },
  cutoutBatchConversionsDesc: {
    id: 'pages.modal.cutoutBatchConversionsDesc',
    defaultMessage: 'Adds a named format to each image instead of new assets.',
  },
  cutoutBatchCost: {
    id: 'pages.modal.cutoutBatchCost',
    // `rate` is a slot, not a literal: the per-image price comes from the
    // sysadmin-editable rate card, so a baked-in "2" would outlive a re-price.
    defaultMessage:
      '{count, plural, one {# image} other {# images}} \u00d7 {rate} credits = {credits} credits',
  },
  cutoutBatchAllOrNothing: {
    id: 'pages.modal.cutoutBatchAllOrNothing',
    defaultMessage:
      'The whole batch is checked against your balance up front. If it does not fit, nothing is started \u2014 no images are half-processed.',
  },
  cutoutBatchStart: {
    id: 'pages.modal.cutoutBatchStart',
    defaultMessage: 'Start on {count, plural, one {# image} other {# images}}',
  },
  cutoutBatchQueued: {
    id: 'pages.modal.cutoutBatchQueued',
    defaultMessage: 'Started on {count} images ({credits} credits). Track it here.',
  },
  cutoutAccessLabel: {
    id: 'pages.modal.cutoutAccessLabel',
    defaultMessage: 'Who can see the result',
  },
  cutoutAccessPublic: {
    id: 'pages.modal.cutoutAccessPublic',
    defaultMessage: 'Public',
  },
  cutoutAccessPublicHint: {
    id: 'pages.modal.cutoutAccessPublicHint',
    defaultMessage: 'Anyone with the link. Needed for a website, marketplace or CDN.',
  },
  cutoutAccessPrivate: {
    id: 'pages.modal.cutoutAccessPrivate',
    defaultMessage: 'Private',
  },
  cutoutAccessPrivateHint: {
    id: 'pages.modal.cutoutAccessPrivateHint',
    defaultMessage: 'Signed links only, like the rest of your private assets.',
  },
  cutoutBatchAlreadyRunning: {
    id: 'pages.modal.cutoutBatchAlreadyRunning',
    defaultMessage:
      'A background removal batch is already running. Wait for it to finish, then start the next one.',
  },
});

export default messages;

// Which message to show for a failed save (an upload), from a `FetchResult`
// error's status or a thrown `{status}`. Shared by the image editor and the
// cutout dialog.
export function saveErrorMessage(status?: number) {
  if (status === 503) return messages.savePaused;
  if (status === 403) return messages.saveRefused;
  return messages.saveFailed;
}
